import "../assets/css/profile.css";
import request from "../shared/utils/request";
import { useEffect, useState } from "react";
import HeaderLogo from "../assets/img/logo-es.webp";
import MobileMenu from "./MobileMenu";

export const ProfileView = () => {
  const [studentDetails, setStudentDetails] = useState(null);
  useEffect(() => {
    getProfile();
  }, []);

  const getProfile = async () => {
    // setLoader(true);
    const response = await request.get("student/getStudentProfile");
    if (response) {
      if (response?.data?.data?.payment_status === "Pending") {
        window.location.href = "/student/payment";
      } else {
        setStudentDetails(response?.data?.data);
        localStorage.setItem(
          "courseType",
          response?.data?.data?.subscriptions?.[0]?.course?.type
        );
        //   setLoader(false);
      }
    }
  };
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="navbar navbar-expand-lg w-100">
      <div className="container">
        <div className="row">
        <div className="col-4 ">
            <i
              className="header-toggle d-xl-none bi bi-list"
              onClick={toggleMenu}
              role="button"
              tabIndex={0}
              style={{ cursor: "pointer" }}
            ></i>
            <MobileMenu menuOpen={menuOpen} toggleMenu={toggleMenu} />
          </div>
          <div className="col-md-2 col-4  d-block d-lg-none">
            <a className="navbar-brand" href="#">
              <img
                className="img-fluid"
                src={HeaderLogo}
                alt="English Studio"
              />
            </a>
          </div>
        
          <div className="col-4 d-flex justify-content-end">
            <div className="profile-wrapper position-relative d-block d-lg-none">
              <div className="profile-icon">
                {studentDetails?.name?.charAt(0)}
              </div>
              <div className="profile-dropdown">
                <div className="profile-card">
                  <div className="profile-header">
                    <div className="profile-avatar">
                      {studentDetails?.name?.charAt(0)}
                    </div>
                    <h6 className="profile-name">{studentDetails?.name}</h6>
                    <div className="profile-email">
                      <i className="fas fa-circle" />
                    </div>
                    <div className="profile-role">{studentDetails?.email}</div>
                  </div>
                  <ul className="list-group list-group-flush">
                    {/* <li className="list-group-item">
                  <i class="bi bi-person-gear"></i>&nbsp;
                  <span>My Profile</span>
                </li>
                <li className="list-group-item">
                  <i class="bi bi-credit-card-2-back"></i> &nbsp;
                  <span>Subscriptions</span>
                </li> */}
                    <li
                      className="list-group-item"
                      onClick={() => {
                        window.open(
                          "https://englishstudio.in/faq/",
                          "_blank"
                        );
                      }}
                    >
                      <i class="bi bi-patch-question "></i> &nbsp;
                      <span>FAQ</span>
                    </li>
                    <li
                      className="list-group-item"
                      onClick={() => {
                        window.open(
                          "https://englishstudio.in/code-of-conduct/",
                          "_blank"
                        );
                      }}
                    >
                      <i class="bi bi-file-earmark-ruled"></i> &nbsp;
                      <span>Code of Conduct</span>
                    </li>
                    <li
                      className="list-group-item"
                      onClick={() => {
                        window.open(
                          "https://englishstudio.in/privacy-policy/",
                          "_blank"
                        );
                      }}
                    >
                      <i class="bi bi-shield-check"></i> &nbsp;
                      <span>Privacy Policy</span>
                    </li>
                    <li
                      className="list-group-item logout-item"
                      onClick={() => {
                        localStorage.clear();
                        window.location.href = "/";
                      }}
                    >
                      <i class="bi bi-power"></i> &nbsp;
                      <span>Logout</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        
        </div>
      <div className="row d-none d-lg-flex">
  <div className="col-md-2">
    <a className="navbar-brand" href="#">
      <img
        className="img-fluid"
        src={HeaderLogo}
        alt="English Studio"
      />
    </a>
  </div>
  <div className="col-md-10 d-flex justify-content-end">
    <div className="profile-wrapper position-relative">
      <div className="profile-icon">
        {studentDetails?.name?.charAt(0)}
      </div>
      <div className="profile-dropdown">
        <div className="profile-card">
          <div className="profile-header">
            <div className="profile-avatar">
              {studentDetails?.name?.charAt(0)}
            </div>
            <h6 className="profile-name">{studentDetails?.name}</h6>
            <div className="profile-email">
              <i className="fas fa-circle" />
            </div>
            <div className="profile-role">{studentDetails?.email}</div>
          </div>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              onClick={() => {
                window.open(
                  "https://englishstudio.in/faq/",
                  "_blank"
                );
              }}
            >
              <i className="bi bi-patch-question "></i> &nbsp;
              <span>FAQ</span>
            </li>
            <li
              className="list-group-item"
              onClick={() => {
                window.open(
                  "https://englishstudio.in/code-of-conduct/",
                  "_blank"
                );
              }}
            >
              <i className="bi bi-file-earmark-ruled"></i> &nbsp;
              <span>Code of Conduct</span>
            </li>
            <li
              className="list-group-item"
              onClick={() => {
                window.open(
                  "https://englishstudio.in/privacy-policy/",
                  "_blank"
                );
              }}
            >
              <i className="bi bi-shield-check"></i> &nbsp;
              <span>Privacy Policy</span>
            </li>
            <li
              className="list-group-item logout-item"
              onClick={() => {
                localStorage.clear();
                window.location.href = "/";
              }}
            >
              <i className="bi bi-power"></i> &nbsp;
              <span>Logout</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>            </div>
    </nav>
  );
};
